/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePendingMessageResponse } from '../../models/api-response-pending-message-response';
import { UpdatePendingMessageRequest } from '../../models/update-pending-message-request';

export interface UpdatePendingMessage$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  reference: string;
      body: UpdatePendingMessageRequest
}

export function updatePendingMessage(http: HttpClient, rootUrl: string, params: UpdatePendingMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePendingMessageResponse>> {
  const rb = new RequestBuilder(rootUrl, updatePendingMessage.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('reference', params.reference, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePendingMessageResponse>;
    })
  );
}

updatePendingMessage.PATH = '/v1/api/pending-messages/{reference}';
